// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"272":"860b47e1","3511":"a332b565","5046":"f7f59c36","5465":"b075d87a","7106":"eed4db5c","7812":"9b099e0e"}[chunkId] + ".chunk.css";
};